import React, { FC } from 'react';
import { motion } from 'framer-motion';

interface FileAnimationProps {
  hovered: boolean;
}

const FileAnimation: FC<FileAnimationProps> = ({ hovered }) => {
  return (
    <div className="flex items-center justify-center  ">
      <motion.div
        animate={hovered ? { opacity: 0, scale: 0 } : { opacity: 1, scale: 1 }}
        transition={{ ease: 'easeOut', duration: 0.3 }}
      >
        <FileIcon />
      </motion.div>
      <motion.div
        animate={hovered ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0 }}
        transition={{ ease: 'easeOut', duration: 0.3 }}
        className="absolute"
      >
        <FileTypes />
      </motion.div>
      <motion.div
        className=" absolute"
        animate={hovered ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0 }}
        transition={{ ease: 'easeOut', duration: 0.3 }}
      >
        <Vector />
      </motion.div>
    </div>
  );
};

export default FileAnimation;

const FileIcon = () => (
  <svg
    width="34"
    height="46"
    viewBox="0 0 34 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_553_27683" fill="white">
      <path d="M22.5 1.68311H32.0625V11.2456H23.5C22.9477 11.2456 22.5 10.7979 22.5 10.2456V1.68311Z" />
    </mask>
    <path
      d="M22.5 1.68311H32.0625H22.5ZM32.0625 13.2456H23.5C21.8431 13.2456 20.5 11.9025 20.5 10.2456L24.5 9.24561H32.0625V13.2456ZM23.5 13.2456C21.8431 13.2456 20.5 11.9025 20.5 10.2456V1.68311H24.5V9.24561L23.5 13.2456ZM32.0625 1.68311V11.2456V1.68311Z"
      fill="url(#paint0_linear_553_27683)"
      mask="url(#path-1-inside-1_553_27683)"
    />
    <path
      d="M22.5 1.68311H32.0625H22.5ZM32.0625 13.2456H23.5C21.8431 13.2456 20.5 11.9025 20.5 10.2456L24.5 9.24561H32.0625V13.2456ZM23.5 13.2456C21.8431 13.2456 20.5 11.9025 20.5 10.2456V1.68311H24.5V9.24561L23.5 13.2456ZM32.0625 1.68311V11.2456V1.68311Z"
      fill="white"
      fillOpacity="0.12"
      mask="url(#path-1-inside-1_553_27683)"
    />
    <path
      d="M4 1.55811H23.6143L32.75 9.94873V41.5581C32.75 43.2149 31.4068 44.558 29.75 44.5581H4C2.34315 44.5581 1 43.215 1 41.5581V4.55811C1 2.90125 2.34315 1.55811 4 1.55811Z"
      stroke="url(#paint1_linear_553_27683)"
      strokeWidth="2"
    />
    <path
      d="M4 1.55811H23.6143L32.75 9.94873V41.5581C32.75 43.2149 31.4068 44.558 29.75 44.5581H4C2.34315 44.5581 1 43.215 1 41.5581V4.55811C1 2.90125 2.34315 1.55811 4 1.55811Z"
      stroke="white"
      strokeOpacity="0.12"
      strokeWidth="2"
    />
    <defs>
      <linearGradient
        id="paint0_linear_553_27683"
        x1="23"
        y1="1.55811"
        x2="33"
        y2="10.0581"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8AA1FF" />
        <stop offset="1" stopColor="#86CAE6" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_553_27683"
        x1="-0.999999"
        y1="17.0581"
        x2="32"
        y2="35.0581"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7E77B3" />
        <stop offset="0.25" stopColor="#8989FF" />
        <stop offset="0.499" stopColor="#6C9DFF" />
        <stop offset="0.75" stopColor="#78CFDA" />
        <stop offset="1" stopColor="#9FF4A9" />
      </linearGradient>
    </defs>
  </svg>
);

const FileTypes = () => (
  <svg
    width="101"
    height="55"
    viewBox="0 0 101 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_678_73839)">
      <path
        d="M79.0837 17.7672L90.4789 22.8407L93.6787 30.2228L85.4149 48.7836C84.9189 49.8976 83.6137 50.3987 82.4997 49.9027L67.7081 43.317C66.5941 42.8211 66.0932 41.5159 66.5891 40.4019L76.1685 18.8862C76.6645 17.7722 77.9696 17.2712 79.0837 17.7672Z"
        stroke="#BBBAFA"
        strokeWidth="1.472"
      />
      <mask id="path-2-inside-1_678_73839" fill="white">
        <path d="M89.8418 22.5566L95.5569 25.1012L93.0124 30.8163L87.9696 28.5711C87.5983 28.4058 87.4313 27.9708 87.5966 27.5994L89.8418 22.5566Z" />
      </mask>
      <path
        d="M89.8418 22.5566L95.5569 25.1012L89.8418 22.5566ZM92.4137 32.1611L87.3709 29.9159C86.2569 29.4199 85.7559 28.1147 86.2519 27.0007L89.2407 27.5258L93.6111 29.4716L92.4137 32.1611ZM87.3709 29.9159C86.2569 29.4199 85.7559 28.1147 86.2519 27.0007L88.4971 21.9579L91.1865 23.1554L89.2407 27.5258L87.3709 29.9159ZM95.5569 25.1012L93.0124 30.8163L95.5569 25.1012Z"
        fill="#BBBAFA"
        mask="url(#path-2-inside-1_678_73839)"
      />
      <rect
        x="68.0176"
        y="28.147"
        width="16.944"
        height="9.416"
        rx="1.472"
        transform="rotate(24 68.0176 28.147)"
        fill="#9796F3"
      />
      <path
        d="M71.886 33.9242C71.7643 34.1976 71.5897 34.4207 71.3625 34.5934C71.1372 34.7616 70.8636 34.8574 70.5417 34.8806C70.2199 34.9038 69.8662 34.8296 69.4807 34.6579L68.768 34.3406L68.0136 36.035L66.8639 35.5231L68.9654 30.803L70.8278 31.6323C71.2044 31.7999 71.4937 32.0066 71.6958 32.2523C71.8979 32.4981 72.013 32.7642 72.0413 33.0507C72.0695 33.3372 72.0177 33.6283 71.886 33.9242ZM69.8004 33.7046C70.0201 33.8024 70.2066 33.8237 70.3601 33.7685C70.5136 33.7133 70.6323 33.5915 70.7161 33.4033C70.7999 33.215 70.811 33.0454 70.7493 32.8944C70.6876 32.7434 70.5469 32.619 70.3273 32.5212L69.702 32.2428L69.1751 33.4262L69.8004 33.7046ZM74.9294 33.4584C75.427 33.6799 75.8179 33.9721 76.1021 34.335C76.3864 34.6979 76.5495 35.1035 76.5916 35.5519C76.6401 35.9979 76.5606 36.4539 76.353 36.9201C76.1475 37.3818 75.8618 37.746 75.4959 38.0128C75.1345 38.2816 74.7217 38.4308 74.2573 38.4604C73.7975 38.492 73.321 38.398 72.8279 38.1785L71.0596 37.3911L73.1611 32.6711L74.9294 33.4584ZM73.197 37.1504C73.6318 37.344 74.0232 37.3759 74.371 37.2461C74.7188 37.1163 74.9895 36.834 75.1831 36.3992C75.3767 35.9644 75.4063 35.5721 75.272 35.2223C75.1378 34.8724 74.8532 34.6007 74.4184 34.4072L73.8738 34.1647L72.6524 36.9079L73.197 37.1504ZM81.119 36.2142L80.7089 37.1353L78.7859 36.2792L78.3429 37.2743L79.7817 37.9149L79.3836 38.8092L77.9447 38.1685L77.0946 40.0781L75.9448 39.5662L78.0463 34.8461L81.119 36.2142Z"
        fill="#191925"
      />
    </g>
    <g clipPath="url(#clip1_678_73839)">
      <path
        d="M42.3115 0.775391H54.7852L60.7109 6.21777V26.5352C60.7109 27.7546 59.7223 28.7432 58.5029 28.7432H42.3115C41.0921 28.7432 40.1036 27.7546 40.1035 26.5352V2.9834C40.1035 1.76395 41.0921 0.775391 42.3115 0.775391Z"
        stroke="#C8DDF6"
        strokeWidth="1.472"
      />
      <mask id="path-7-inside-2_678_73839" fill="white">
        <path d="M54.0879 0.774902H60.3439V7.0309H54.8239C54.4174 7.0309 54.0879 6.70138 54.0879 6.2949V0.774902Z" />
      </mask>
      <path
        d="M54.0879 0.774902H60.3439H54.0879ZM60.3439 8.5029H54.8239C53.6044 8.5029 52.6159 7.51435 52.6159 6.2949L55.5599 5.5589H60.3439V8.5029ZM54.8239 8.5029C53.6044 8.5029 52.6159 7.51435 52.6159 6.2949V0.774902H55.5599V5.5589L54.8239 8.5029ZM60.3439 0.774902V7.0309V0.774902Z"
        fill="#C8DDF6"
        mask="url(#path-7-inside-2_678_73839)"
      />
      <path
        d="M54.1222 15.0391H47.2528C46.7108 15.0391 46.2715 15.4784 46.2715 16.0204V22.8897C46.2715 23.4317 46.7108 23.8711 47.2528 23.8711H54.1222C54.6641 23.8711 55.1035 23.4317 55.1035 22.8897V16.0204C55.1035 15.4784 54.6641 15.0391 54.1222 15.0391Z"
        stroke="#6C9DFF"
        strokeWidth="0.981333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.1046 20.927L52.6512 18.4736L47.2539 23.871"
        stroke="#6C9DFF"
        strokeWidth="0.981333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.9704 18.4735C49.3769 18.4735 49.7064 18.1439 49.7064 17.7375C49.7064 17.331 49.3769 17.0015 48.9704 17.0015C48.5639 17.0015 48.2344 17.331 48.2344 17.7375C48.2344 18.1439 48.5639 18.4735 48.9704 18.4735Z"
        stroke="#6C9DFF"
        strokeWidth="0.981333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip2_678_73839)">
      <path
        d="M6.94045 24.3545L18.3357 19.281L25.9628 21.8426L34.2266 40.4035C34.7225 41.5175 34.2215 42.8227 33.1076 43.3187L18.316 49.9043C17.202 50.4003 15.8968 49.8992 15.4008 48.7853L5.82141 27.2697C5.32542 26.1557 5.82643 24.8505 6.94045 24.3545Z"
        stroke="#CDFFD3"
        strokeWidth="1.472"
      />
      <mask id="path-13-inside-3_678_73839" fill="white">
        <path d="M17.6973 19.5645L23.4124 17.0199L25.957 22.735L20.9142 24.9802C20.5428 25.1456 20.1078 24.9786 19.9425 24.6072L17.6973 19.5645Z" />
      </mask>
      <path
        d="M17.6973 19.5645L23.4124 17.0199L17.6973 19.5645ZM26.5557 24.0798L21.5129 26.325C20.3989 26.821 19.0937 26.32 18.5977 25.2059L20.9878 23.3361L25.3582 21.3903L26.5557 24.0798ZM21.5129 26.325C20.3989 26.821 19.0937 26.32 18.5977 25.2059L16.3525 20.1632L19.042 18.9657L20.9878 23.3361L21.5129 26.325ZM23.4124 17.0199L25.957 22.735L23.4124 17.0199Z"
        fill="#CDFFD3"
        mask="url(#path-13-inside-3_678_73839)"
      />
      <rect
        x="7.24805"
        y="39.5239"
        width="18.944"
        height="9.416"
        rx="1.472"
        transform="rotate(-24 7.24805 39.5239)"
        fill="#A7FFB2"
      />
      <path
        d="M14.2348 40.4683C14.3565 40.7417 14.4055 41.0206 14.3818 41.3051C14.3561 41.5851 14.2442 41.8525 14.046 42.1072C13.8479 42.3619 13.5561 42.5751 13.1706 42.7467L12.4579 43.064L13.2123 44.7584L12.0625 45.2703L9.96105 40.5503L11.8235 39.721C12.2 39.5534 12.5472 39.4767 12.8651 39.4909C13.183 39.5052 13.4578 39.5977 13.6895 39.7684C13.9213 39.9391 14.1031 40.1724 14.2348 40.4683ZM12.6761 41.8712C12.8957 41.7734 13.0364 41.649 13.0981 41.498C13.1597 41.347 13.1487 41.1774 13.0649 40.9891C12.981 40.8009 12.8624 40.6791 12.7089 40.6239C12.5554 40.5687 12.3689 40.59 12.1492 40.6878L11.5239 40.9662L12.0508 42.1496L12.6761 41.8712ZM20.4808 41.5223L19.331 42.0342L16.1118 39.979L17.408 42.8903L16.2583 43.4022L14.1568 38.6822L15.3065 38.1703L18.5317 40.2389L17.2295 37.3141L18.3793 36.8022L20.4808 41.5223ZM23.0105 36.5288C22.8555 36.4098 22.6793 36.3459 22.4821 36.3371C22.2872 36.3218 22.0823 36.362 21.8671 36.4578C21.4951 36.6235 21.2519 36.8795 21.1375 37.2258C21.0211 37.5676 21.0538 37.9425 21.2354 38.3504C21.429 38.7852 21.6972 39.074 22.04 39.2167C22.3854 39.353 22.7642 39.3293 23.1766 39.1457C23.459 39.02 23.6647 38.8425 23.7936 38.6133C23.9269 38.382 23.9786 38.1119 23.9485 37.8031L22.4894 38.4527L22.1122 37.6055L24.6134 36.4919L25.0894 37.561C25.132 37.8858 25.105 38.2173 25.0086 38.5557C24.9167 38.892 24.7477 39.2062 24.5018 39.4983C24.2559 39.7904 23.9357 40.0243 23.5413 40.1999C23.0751 40.4075 22.6133 40.4922 22.1559 40.4542C21.7011 40.4096 21.2897 40.2517 20.9218 39.9804C20.5585 39.7072 20.273 39.3374 20.0655 38.8713C19.8579 38.4051 19.7742 37.9456 19.8142 37.4927C19.8568 37.0333 20.0147 36.6219 20.2879 36.2586C20.5592 35.8907 20.9279 35.603 21.3941 35.3955C21.9589 35.144 22.4949 35.0692 23.0022 35.171C23.5139 35.2708 23.9402 35.5348 24.2813 35.963L23.0105 36.5288Z"
        fill="#191925"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50 37.9746C50.3452 37.9746 50.625 38.2544 50.625 38.5996V43.5996H55.625C55.9702 43.5996 56.25 43.8794 56.25 44.2246C56.25 44.5698 55.9702 44.8496 55.625 44.8496H50.625V49.8496C50.625 50.1948 50.3452 50.4746 50 50.4746C49.6548 50.4746 49.375 50.1948 49.375 49.8496V44.8496H44.375C44.0298 44.8496 43.75 44.5698 43.75 44.2246C43.75 43.8794 44.0298 43.5996 44.375 43.5996H49.375V38.5996C49.375 38.2544 49.6548 37.9746 50 37.9746Z"
      fill="#F8FAFC"
    />
    <defs>
      <clipPath id="clip0_678_73839">
        <rect
          width="29.44"
          height="29.44"
          fill="white"
          transform="translate(73.332 14.4004) rotate(24)"
        />
      </clipPath>
      <clipPath id="clip1_678_73839">
        <rect
          width="29.44"
          height="29.44"
          fill="white"
          transform="translate(35.6875 0.0390625)"
        />
      </clipPath>
      <clipPath id="clip2_678_73839">
        <rect
          width="29.44"
          height="29.44"
          fill="white"
          transform="translate(0.587891 26.376) rotate(-24)"
        />
      </clipPath>
    </defs>
  </svg>
);
const Vector = () => (
  <svg
    width="219"
    height="218"
    viewBox="0 0 219 218"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.19" filter="url(#filter0_f_678_73837)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.804 80.3688C119.479 81.1294 125.789 86.2759 130.636 92.3195C134.939 97.6841 135.885 104.434 136.607 111.293C137.461 119.399 140.904 129.083 135.105 134.768C129.314 140.444 119.813 136.678 111.804 135.608C105.304 134.74 99.1703 133.28 93.9581 129.272C87.7478 124.497 81.1492 119.103 80.1808 111.293C79.1272 102.795 82.7638 94.1446 88.863 88.1803C94.8843 82.2921 103.453 79.5413 111.804 80.3688Z"
        fill="#8989FF"
        fillOpacity="0.56"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_678_73837"
        x="0"
        y="0.224609"
        width="218.4"
        height="217.6"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="40"
          result="effect1_foregroundBlur_678_73837"
        />
      </filter>
    </defs>
  </svg>
);

export const PNGFile = () => (
  <svg
    width="30"
    height="31"
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_678_57051)">
      <path
        d="M6.62402 1.3501L19.0977 1.3501L25.0234 6.79248V27.1099C25.0234 28.3293 24.0348 29.3179 22.8154 29.3179H6.62402C5.40461 29.3179 4.41607 28.3293 4.41602 27.1099L4.41602 3.55811C4.41602 2.33866 5.40458 1.3501 6.62402 1.3501Z"
        stroke="#F8FAFC"
        strokeWidth="1.472"
      />
      <mask id="path-2-inside-1_678_57051" fill="white">
        <path d="M18.4004 1.34961L24.6564 1.34961V7.60561H19.1364C18.7299 7.60561 18.4004 7.27609 18.4004 6.86961V1.34961Z" />
      </mask>
      <path
        d="M18.4004 1.34961L24.6564 1.34961L18.4004 1.34961ZM24.6564 9.07761H19.1364C17.9169 9.07761 16.9284 8.08905 16.9284 6.86961L19.8724 6.13361H24.6564V9.07761ZM19.1364 9.07761C17.9169 9.07761 16.9284 8.08905 16.9284 6.86961V1.34961H19.8724V6.13361L19.1364 9.07761ZM24.6564 1.34961V7.60561V1.34961Z"
        fill="#F8FAFC"
        mask="url(#path-2-inside-1_678_57051)"
      />
      <rect
        x="0.736328"
        y="15.333"
        width="18.944"
        height="9.416"
        rx="1.472"
        fill="#F8FAFC"
      />
      <path
        d="M6.73619 19.0377C6.73619 19.337 6.66749 19.6117 6.53011 19.862C6.39272 20.1073 6.18173 20.306 5.89715 20.4581C5.61256 20.6102 5.25928 20.6863 4.83731 20.6863H4.05715V22.541H2.79859V17.3743H4.83731C5.24947 17.3743 5.59784 17.4454 5.88243 17.5877C6.16701 17.73 6.38045 17.9263 6.52275 18.1765C6.66504 18.4268 6.73619 18.7138 6.73619 19.0377ZM4.74163 19.6853C4.98205 19.6853 5.16115 19.6289 5.27891 19.5161C5.39667 19.4032 5.45555 19.2437 5.45555 19.0377C5.45555 18.8316 5.39667 18.6721 5.27891 18.5593C5.16115 18.4464 4.98205 18.39 4.74163 18.39H4.05715V19.6853H4.74163ZM12.0135 22.541H10.7549L8.64996 19.3541V22.541H7.3914V17.3743H8.64996L10.7549 20.5759V17.3743H12.0135V22.541ZM16.3555 19.0082C16.2623 18.8365 16.1274 18.7065 15.9507 18.6181C15.779 18.5249 15.5754 18.4783 15.3399 18.4783C14.9326 18.4783 14.6063 18.6132 14.361 18.8831C14.1156 19.1481 13.993 19.5038 13.993 19.9503C13.993 20.4262 14.1205 20.7991 14.3757 21.069C14.6357 21.334 14.9915 21.4665 15.4429 21.4665C15.752 21.4665 16.0121 21.3879 16.2231 21.2309C16.4389 21.0739 16.596 20.8482 16.6941 20.5538H15.097V19.6265H17.8349V20.7967C17.7417 21.1107 17.5822 21.4027 17.3565 21.6725C17.1357 21.9424 16.8536 22.1607 16.5101 22.3276C16.1666 22.4944 15.779 22.5778 15.3472 22.5778C14.8369 22.5778 14.3806 22.4674 13.9783 22.2466C13.5808 22.0209 13.2692 21.7093 13.0435 21.3119C12.8227 20.9145 12.7123 20.4606 12.7123 19.9503C12.7123 19.44 12.8227 18.9861 13.0435 18.5887C13.2692 18.1863 13.5808 17.8748 13.9783 17.654C14.3757 17.4283 14.8296 17.3154 15.3399 17.3154C15.9581 17.3154 16.4782 17.4651 16.9002 17.7644C17.3271 18.0637 17.6092 18.4783 17.7466 19.0082H16.3555Z"
        fill="#191925"
      />
    </g>
    <defs>
      <clipPath id="clip0_678_57051">
        <rect
          width="29.44"
          height="29.44"
          fill="white"
          transform="translate(0 0.613281)"
        />
      </clipPath>
    </defs>
  </svg>
);
